import * as React from 'react';
import { RadioGroup, RadioGroupItem } from '@repo/ui-web';
import { radioStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

type RadioState = (typeof radioStates)[number];

export function RadioShowcase() {
  const [state, setState] = React.useState<RadioState>('option-1');
  const disabled = state === 'disabled';
  const value = state === 'option-2' ? 'pro' : 'starter';

  return (
    <div className="space-y-4">
      <StateToggle options={radioStates} value={state} onChange={setState} label="State" />
      <RadioGroup value={value} onValueChange={() => null} disabled={disabled}>
        <div className="flex items-center gap-2">
          <RadioGroupItem value="starter" />
          <span className="text-sm font-medium text-foreground">Starter</span>
        </div>
        <div className="flex items-center gap-2">
          <RadioGroupItem value="pro" />
          <span className="text-sm font-medium text-foreground">Pro</span>
        </div>
      </RadioGroup>
    </div>
  );
}
